const translations = {
  // Nav
  "nav.home": "Accueil",
  "nav.mission": "Mission",
  "nav.projects": "Projets",
  "nav.volunteer": "Bénévolat",
  "nav.donate": "Faire un don",
  "nav.contact": "Contact",
  "nav.donateNow": "Faire un don",

  // Language bar
  "lang.managed": "Géré via le tableau de bord CMS Admin",

  // Hero
  "hero.badge": "Construire des ponts · Créer de l'espoir",
  "hero.title": "Autonomiser les communautés afghanes par l'éducation et les opportunités",
  "hero.subtitle": "La Fondation Canada Afghanistan connecte des Canadiens compatissants avec des communautés afghanes dans le besoin — finançant l'éducation, la santé et le développement durable depuis 2016.",
  "hero.cta.donate": "Soutenir notre mission",
  "hero.cta.learn": "Notre histoire",
  "hero.scroll": "Défiler",

  // Mission Preview
  "mission.tag": "Notre Mission",
  "mission.title": "Un pont entre deux nations, bâti sur la compassion",
  "mission.body1": "La Fondation Canada Afghanistan (CAF) est un organisme de bienfaisance canadien enregistré dédié à l'amélioration de la vie des Afghans grâce à des programmes ciblés en éducation, santé et développement communautaire.",
  "mission.body2": "Nous croyons que chaque enfant afghan mérite l'accès à l'éducation, chaque famille mérite de l'eau potable, et chaque communauté mérite la chance de prospérer — peu importe les conflits.",
  "mission.cta": "Lire notre mission complète",
  "mission.pillar.education": "Éducation",
  "mission.pillar.education.desc": "Financement d'écoles, de bourses et de formations professionnelles pour les jeunes et les femmes afghanes.",
  "mission.pillar.healthcare": "Santé",
  "mission.pillar.healthcare.desc": "Déploiement de cliniques mobiles et soutien aux professionnels de santé dans les régions mal desservies.",
  "mission.pillar.community": "Communauté",
  "mission.pillar.community.desc": "Construction d'infrastructures, accès à l'eau potable et soutien à la réinstallation des réfugiés au Canada.",
  "mission.pillar.sustainability": "Durabilité",
  "mission.pillar.sustainability.desc": "Autonomisation des leaders locaux pour créer un changement durable et autosuffisant.",

  // Projects Preview
  "projects.tag": "Initiatives actives",
  "projects.title": "Nos projets actuels",
  "projects.subtitle": "Chaque projet est soigneusement conçu pour créer un impact durable dans les communautés afghanes.",
  "projects.viewAll": "Voir tous les projets",
  "projects.learnMore": "En savoir plus",
  "projects.raised": "Collecté",
  "projects.completed": "Terminé",

  // Impact
  "impact.tag": "Notre Impact",
  "impact.title": "Un changement réel, des chiffres réels",
  "impact.subtitle": "Chaque dollar donné se traduit par un impact mesurable sur le terrain. Voici ce que nous avons accompli ensemble.",
  "impact.students": "Étudiants soutenus",
  "impact.students.desc": "Filles et garçons recevant une éducation de qualité grâce à nos programmes de bourses.",
  "impact.water": "Personnes avec eau potable",
  "impact.water.desc": "Familles en Afghanistan rural ayant maintenant accès à de l'eau potable sûre.",
  "impact.medical": "Consultations médicales",
  "impact.medical.desc": "Soins de santé gratuits fournis via notre programme de cliniques mobiles depuis 2018.",
  "impact.families": "Familles réinstallées",
  "impact.families.desc": "Familles de réfugiés afghans soutenues dans leur nouvelle vie au Canada.",

  // Volunteer Preview
  "volunteer.tag": "S'impliquer",
  "volunteer.title": "Rejoignez notre communauté de bâtisseurs de changement",
  "volunteer.body1": "Que vous soyez médecin, traducteur, collecteur de fonds ou passionné des réseaux sociaux — il y a une place pour vous à la CAF.",
  "volunteer.body2": "Nous avons des opportunités de bénévolat pour les Canadiens et les membres de la diaspora afghane, en présentiel et à distance.",
  "volunteer.cta": "Devenir bénévole",
  "volunteer.otherWays": "Ou explorez d'autres façons d'aider",
  "volunteer.apply": "Postuler",
  "volunteer.location": "Lieu",

  // Donate Preview
  "donate.tag": "Faire la différence",
  "donate.title": "Votre don, leur avenir",
  "donate.subtitle": "100% de votre don va directement aux programmes sur le terrain. Nous sommes un organisme de bienfaisance canadien enregistré — tous les dons sont déductibles d'impôt.",
  "donate.tier.supporter": "Soutien",
  "donate.tier.champion": "Champion",
  "donate.tier.patron": "Mécène",
  "donate.mostPopular": "Le plus populaire",
  "donate.highImpact": "Fort impact",
  "donate.donate": "Donner",
  "donate.trust.charity": "Organisme de bienfaisance canadien enregistré",
  "donate.trust.transparent": "100% Transparent",
  "donate.trust.receipts": "Reçus fiscaux émis",
  "donate.trust.secure": "Traitement sécurisé",

  // Footer
  "footer.tagline": "Construire des ponts entre le Canada et l'Afghanistan par l'éducation, la santé et le développement communautaire.",
  "footer.charity": "Organisme de bienfaisance ARC #123456789",
  "footer.est": "Fondé en 2016",
  "footer.quickLinks": "Liens rapides",
  "footer.getInvolved": "S'impliquer",
  "footer.stayConnected": "Rester connecté",
  "footer.newsletter.desc": "Recevez des mises à jour mensuelles sur notre impact et comment vous pouvez aider.",
  "footer.newsletter.placeholder": "Votre adresse e-mail",
  "footer.newsletter.success": "Merci de vous être abonné!",
  "footer.newsletter.privacy": "Nous respectons votre vie privée. Désabonnez-vous à tout moment.",
  "footer.support": "Assistance disponible en:",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions d'utilisation",
  "footer.accessibility": "Accessibilité",
  "footer.admin": "Admin",
  "footer.copyright": "Fondation Canada Afghanistan. Tous droits réservés.",

  // Contact
  "contact.tag": "Nous contacter",
  "contact.title": "Nous serions ravis de vous entendre",
  "contact.subtitle": "Des questions sur nos programmes, vous souhaitez vous associer à nous? Contactez-nous — nous répondons en anglais, pachto, dari, français et allemand.",
  "contact.form.name": "Nom complet",
  "contact.form.email": "Adresse e-mail",
  "contact.form.subject": "Sujet",
  "contact.form.message": "Votre message",
  "contact.form.submit": "Envoyer le message",
  "contact.form.sending": "Envoi en cours...",
  "contact.form.success": "Message envoyé! Nous vous répondrons dans les 48 heures.",
  "contact.info.address": "Adresse",
  "contact.info.email": "E-mail",
  "contact.info.phone": "Téléphone",
  "contact.info.hours": "Heures de bureau",

  // Mission Page
  "missionPage.tag": "Notre Mission",
  "missionPage.title": "Une mission ancrée dans l'espoir, portée par l'action",
  "missionPage.subtitle": "La Fondation Canada Afghanistan existe pour combler le fossé entre les Canadiens compatissants et les communautés afghanes dans le besoin.",
  "missionPage.who.tag": "Qui nous sommes",
  "missionPage.who.title": "Construire des ponts entre deux nations",
  "missionPage.values.tag": "Ce qui nous guide",
  "missionPage.values.title": "Nos valeurs fondamentales",
  "missionPage.timeline.tag": "Notre parcours",
  "missionPage.timeline.title": "8 ans d'impact",
  "missionPage.cta.title": "Faites partie de la mission",
  "missionPage.cta.subtitle": "Que vous fassiez un don, du bénévolat ou simplement que vous passiez le mot — vous faites partie du changement.",
  "missionPage.cta.donate": "Faire un don",
  "missionPage.cta.volunteer": "Devenir bénévole",

  // Donate Page
  "donatePage.tag": "Soutenir notre travail",
  "donatePage.title": "Créer un impact durable",
  "donatePage.subtitle": "Votre générosité finance de vrais programmes qui changent de vraies vies.",

  // Volunteer Page
  "volunteerPage.tag": "Bénévolat avec la CAF",
  "volunteerPage.title": "Vos compétences peuvent changer des vies",
  "volunteerPage.subtitle": "Rejoignez notre réseau mondial de bénévoles dévoués qui font une différence pour les communautés afghanes.",
};

export default translations;
